import { render } from "./Temperature.vue?vue&type=template&id=3acb4eb0&scoped=true&ts=true"
import script from "./Temperature.vue?vue&type=script&lang=ts"
export * from "./Temperature.vue?vue&type=script&lang=ts"

import "./Temperature.vue?vue&type=style&index=0&id=3acb4eb0&scoped=true&lang=less"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acb4eb0"]])

export default __exports__